export default "__VITE_ASSET__6ce7b4d9__"